module.exports = __webpack_public_path__ + "static/media/minus.2e9ba9e1.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/minus.svg
// module id = ./src/assets/icons/minus.svg
// module chunks = 0